if (!customElements.get('mv-sticky-cart')) {
  class MiravonnStickyCart extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.mobile = window.matchMedia('(max-width: 749px)');
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      };
      this.addEventListener('click', (event) => {
        if (!event.target.closest('[data-sticky-submit]')) return;
        const main = document.getElementById(this.dataset.sectionId);
        const native = main?.querySelector('button[name="add"]');
        if (!native || native.disabled) return;
        native.click();
        this.schedule();
      }, { signal: this.abort.signal });
      document.addEventListener('scroll', this.schedule, { passive: true, capture: true, signal: this.abort.signal });
      window.addEventListener('resize', this.schedule, { passive: true, signal: this.abort.signal });
      window.visualViewport?.addEventListener('resize', this.schedule, { passive: true, signal: this.abort.signal });
      window.visualViewport?.addEventListener('scroll', this.schedule, { passive: true, signal: this.abort.signal });
      document.addEventListener('change', this.schedule, { signal: this.abort.signal });
      document.addEventListener('shopify:section:load', this.schedule, { signal: this.abort.signal });
      this.mobile.addEventListener('change', this.schedule, { signal: this.abort.signal });
      this.mutations = new MutationObserver(this.schedule);
      this.mutations.observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'open', 'aria-hidden', 'aria-modal', 'hidden', 'value'] });
      this.intersections = new IntersectionObserver(this.schedule, { threshold: [0, 1] });
      this.update();
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.mutations?.disconnect();
      this.intersections?.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      document.documentElement.style.removeProperty('--mv-sticky-cart-space');
    }

    visible(element) {
      if (!element || !element.getClientRects().length) return false;
      const style = getComputedStyle(element);
      return style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0';
    }

    update() {
      const section = document.getElementById(this.dataset.sectionId);
      const native = section?.querySelector('button[name="add"]');
      if (native !== this.native) {
        if (this.native) this.intersections.unobserve(this.native);
        this.native = native;
        if (native) this.intersections.observe(native);
      }
      const viewport = window.visualViewport;
      const top = viewport?.offsetTop || 0;
      const bottom = top + (viewport?.height || window.innerHeight);
      const rect = native?.getBoundingClientRect();
      const header = document.querySelector('#header-component');
      const headerRect = header?.getBoundingClientRect();
      const fixedHeaderBottom = headerRect && headerRect.top <= top && headerRect.bottom > top ? headerRect.bottom : top;
      const nativeVisible = this.visible(native) && rect.bottom > fixedHeaderBottom && rect.top < bottom && rect.right > 0 && rect.left < window.innerWidth;
      const overlayOpen = Array.from(document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], #shopify-pc__banner, [class*="ai-ugc-video-slider__lightbox-"].active')).some((element) => this.visible(element));
      const shown = Boolean(this.mobile.matches && native && !nativeVisible && !overlayOpen);
      if (this.hidden === shown) this.hidden = !shown;
      const space = shown ? `${Math.ceil(this.getBoundingClientRect().height)}px` : '0px';
      if (document.documentElement.style.getPropertyValue('--mv-sticky-cart-space') !== space) document.documentElement.style.setProperty('--mv-sticky-cart-space', space);
      const button = this.querySelector('[data-sticky-submit]');
      if (button && native) {
        const disabled = native.disabled || native.getAttribute('aria-disabled') === 'true';
        if (button.disabled !== disabled) button.disabled = disabled;
        const nativeLabel = native.querySelector('.add-to-cart-text__content')?.textContent?.trim();
        const text = nativeLabel || (disabled ? this.dataset.unavailableLabel : this.dataset.addLabel);
        if (button.textContent !== text) button.textContent = text;
      }
      const form = native?.closest('form');
      const variantId = form?.querySelector('input[name="id"]')?.value;
      const variants = this.querySelector('[data-sticky-variants]');
      if (variants && !this.variants) this.variants = JSON.parse(variants.textContent);
      const variant = this.variants?.find((item) => String(item.id) === variantId);
      const selection = this.querySelector('[data-sticky-selection]');
      if (selection && variant && selection.textContent !== variant.title) selection.textContent = variant.title;
    }
  }
  customElements.define('mv-sticky-cart', MiravonnStickyCart);
}

